(function ($) {

    'use strict';
    var permissionPageBtn;
    var permissionToggleBtn;
    var addEditCollabBtn;
    var confirmForm;

    var togglePermissionPage = function () {
        var $it = $(this);
        var $ctn = $it.closest('.popup-content-ctn');
        $it.toggleClass('disabled');
        if ($it.hasClass('create-event') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.manage-events').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-forfaits').removeClass('disabled');
        } else if (($it.hasClass('manage-events') || $it.hasClass('manage-forfaits')) && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-event').addClass('disabled');
            $ctn.find('.one-dashboard-page-box.create-app').addClass('disabled');
        } else if (($it.hasClass('create-event') || $it.hasClass('manage-shop')) && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-app').addClass('disabled');
        } else if ($it.hasClass('manage-transactions') && $it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.virtual-cashier').addClass('disabled');
        } else if ($it.hasClass('create-app') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.create-event').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-events').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-shop').removeClass('disabled');
            $ctn.find('.one-dashboard-page-box.manage-forfaits').removeClass('disabled');
        } else if ($it.hasClass('virtual-cashier') && !$it.hasClass('disabled')) {
            $ctn.find('.one-dashboard-page-box.manage-transactions').removeClass('disabled');
        }
    };

    var togglePermissionStatus = function () {
        var t = $(this);
        var wasSuspended = t.hasClass('suspended');
        var id = t.attr('data-id');
        var colorbar = $('.ptcr' + id + ' .table-status-colorbar');
        var text = $('.ptcr' + id + ' .table-status-text');

        t.toggleClass('suspended');
        if (wasSuspended) {
            t.find('p').html(t.attr('data-deactivate'));
            colorbar.removeClass(colorbar.attr('data-deactivate')).addClass(colorbar.attr('data-activate'));
            text.text(text.attr('data-activate'));
        } else {
            t.find('p').html(t.attr('data-activate'));
            colorbar.removeClass(colorbar.attr('data-activate')).addClass(colorbar.attr('data-deactivate'));
            text.text(text.attr('data-deactivate'));
        }
        t.closest('.popup').find(".popup-inner-close").trigger("click");
        
        var url = '/action/epPermissions?ajax=true';
        url += '&subId=' + id;
        url += '&active=' + (wasSuspended ? "true" : "false");
        // Update field5 active
        ajax(url, function(res) {}, true);
    };

    var checkWidth = function () {
        if ($('.responsive-detector-sm').css('visibility') === 'visible' && $('.permissions-popup.open').length) {
            $('.permissions-popup.open').each(function () {
                $(this).find('.popup-inner-close').trigger('click');
            });
        }
    };

    function submitCollabForm() {
        var btn = $(this);
        var ctn = btn.closest(".permissions-popup");
        var targ = ctn.find(".permission-email-ctn input");
        var name = targ.attr("name");
        var val = targ.val();
        var json = {};
        
        if (!(targ[0] && (name === "email" || name === "subId"))) {
            return;
        }
        
        ctn.find(".one-dashboard-page-box").each(function () {
            var moduleInfos = {};
            moduleInfos["active"] = !$(this).hasClass("disabled");
            
            if($(this).find('input[type=radio]').length !== 0){
                moduleInfos[$(this).find('input[type=radio]').attr("name")] = $(this).find('input[type=radio]:checked').val();
            }

            json["module-" + $(this).attr("data-id")] = moduleInfos;
            
        });
        if (val.trim() === "") {
            targ.addClass("error");
        }
        if (!targ.hasClass("error")) {
            targ.removeClass("error");
            
            var url = "/action/epPermissions?ajax=true";
            url += "&" + name + "=" + encodeURIComponent(val);
            url += "&json=" + encodeURIComponent(JSON.stringify(json));
            
            ajax(url, function (res) {
                if (btn.attr("class").match("add")) {
                    if (res.indexOf("success") !== -1) {
                        ctn.find(".js-form-error-message").slideUp(300);
                        window.location.reload();
                    } else {
                        ctn.find(".js-form-error-message").slideDown(300);
                    }
                } else {
                    ctn.find(".js-form-error-message").slideUp(300);
                    ctn.find(".popup-inner-close").trigger("click");
                    
                    ctn.find(".one-dashboard-page-box").each (function(){
                        var row = ctn.closest(".permissions-table-row");
                        if(!$(this).hasClass("disabled")) {
                            row.find(".permission-allowed[data-id = '" + $(this).attr("data-id") + "']").remove();
                            var sub = (($(this).find(".permission-radio") !== undefined && $(this).find(".permission-radio").length !== 0) ? " (" + $(this).find(".permission-radio input:checked").parent('label').find("span").text() + ")" : "");

                            row.find(".permissions-allowed-ctn").append('<div class="permission-allowed semibold fs12" data-id="' + $(this).attr("data-id") + '">' +
                                    $(this).find(".one-dashboard-page-header").text()
                                    + sub
                                    + '</div>');
                        } else {
                            row.find(".permission-allowed[data-id = '" + $(this).attr("data-id") + "']").remove();
                        }
                    });
                }
            }, true);
        } else {
            console.error("An error occurred.");
        }
    }

    function promptDelete(e) {
        e.preventDefault();
        confirmForm = $(this).closest("form")[0];
        openWindow("permission_profile_prompt_delete", true);

    }
    function confirmAction(e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        closeWindow("permission_profile_prompt_delete");
        if (confirmForm) {
            ajaxBlackout(true);
            confirmForm.submit();
            confirmForm = null;
        }
    }

    var init = function () {
        permissionPageBtn = $('.permissions-popup .one-dashboard-page-box');
        permissionToggleBtn = $('.toggle-profile-permission-btn');

        permissionPageBtn.click(togglePermissionPage);
        permissionToggleBtn.click(togglePermissionStatus);

        addEditCollabBtn = $('.add-collaborator-btn, .edit-collaborator-btn');
        addEditCollabBtn.click(submitCollabForm);

        $('#permission_profile_prompt_delete .popup-inner-content-btn .btn').click(confirmAction);
        $('.permissions-table .table-delete-btn').on('click', promptDelete);
        $('.permission-radio').on('click', function(e){e.stopPropagation()}); // Prevent click on parent button when choosing one of the radio button

        $(window).resize(checkWidth);
    };

    $(window).on('load', init);

})(jQuery);